import React, {Fragment, useEffect, useState} from 'react';
import {Form,Button,Spinner,Table} from 'react-bootstrap';
import axios from 'axios';
import Recepisse from '../../components/RecepisseDepot/index'
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { InputOption } from '../../components/Input';
import { InputCheckbox, InputRadio } from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import Select from 'react-select';
import { options } from '../../components/Test';

const Vacation = ({props}) => {
    const [dataForm, setDataForm] = useState('');
    const[niveau,setNiveau] = useState('')
    const [step, setStep] = useState(1);
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const[ message, setMessage] = useState('');
    const[ messageAlerte, setMessageAlerte] = useState('');
    const[ matieres, setMatieres] = useState('');
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const [length, setLength] = useState('');
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [resultats, setResultats] = useState('');
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "cv":true,
        "copie_carte_id" : true,
        "demande" : true,
        "lettre_motivation" : true,
        "copie_diplome" : true,
        "recommandation1" : true,
        "recommandation2" : true,
        "resume_these" : true,
        "publication_scientifique" : true,
        "attestation_travail" : true,
        "justificatif1" : true,
        "justificatif2" : true,
        "justificatif3" : true,
        "justificatif4" : true,
        "justificatif5" : true,
        "justificatif6" : true,
        "communication" : true,
        "diplome2" : true,
        "diplome3" : true,
        "diplome4" : true,
        "diplome5" : true,
        "diplome6" : true,
        "justificatif7" : true,
        "justificatif8" : true,
        "communication2" : true,
        "communication3" : true,
        "communication4" : true,
        "communication5" : true,
        "publication2" : true,
        "publication3" : true,
        "publication4" : true,
        "publication5" : true,
        "publication6" : true,
        "publication7" : true,
        "publication8" : true,
        "publication9" : true,
        "publication10" : true,
    });
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        // console.log(selectedFiles.publication7)
        const file = event.target.files[0];
        const elements = document.getElementsByName(key)
        if (file?.size < maxFileSize){
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: file
            }));
            
            for (let i = 0; i < elements.length; i++) {
                let element1 = elements[i];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element1.style.border = ""; // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }
        } else {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (let j = 0; j < elements.length; j++) {
                let element = elements[j];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element.style.border = "2px solid #BC0C0C";
                element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }

        }
    };
      useEffect(() => {
        if (dataForm.matiere1 || dataForm.email || dataForm.prenom || dataForm.nom) {
            setErrors(false)
        }
        const timestamp = 1702049442 ;
        const date = new Date(timestamp * 1000)
        console.log(date)
        for ( let i =0; i<options.length;i++) {
            console.log(options.L1[i].value)
        }
        let matieresAVerifier = [
            dataForm.matiere1,
            dataForm.matiere2,
            dataForm.matiere3,
            dataForm.matiere4,
            dataForm.matiere5,
        ];
        //   setMatieres(matieresAVerifier)
          function trouverCategorie(matiere) {
            for (let categorie in options) {
                // console.log(categorie)
              if (options[categorie].some(m => m.value === matiere)) {
                return categorie;
              }
            }
            return '';
          }
          let resultats = {};
          matieresAVerifier.forEach((matiere, index) => {
            resultats[`matiere${index + 1}`] = trouverCategorie(matiere);
            console.log("catégorie par matiere",resultats)
          });
          for (let matiere in resultats) {
            let resultatElement = document.getElementById(matiere + 'Resultat');
            if (resultatElement) {
              resultatElement.textContent = `La matière ${matiere} appartient à la catégorie ${resultats[matiere]}`;
            }
            setResultats(resultats)
          }
      },[dataForm.email,dataForm.nom,dataForm.prenom,length,dataForm.matiere1]) 
      // Exemple d'utilisation
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(dataForm)
    }
    const handleNextStep = () => {
        if (step === 1) {
           if (!dataForm.email  || !dataForm.diplome || !dataForm.prenom|| !dataForm.nom || !dataForm.fonction || !dataForm.telephone || !dataForm.address) {
                setErrors(true)
           }
        else {
            setErrors(false)
            setStep(step + 1)
        }
            
        } else if (step === 2) {
            // console.log(dataForm.type_poste,dataForm.poste,dataForm.ecole_postulee,dataForm.annee_experience,dataForm.pays,dataForm.diplome)
                if (dataForm.ecole_postulee && dataForm.departement && dataForm.matiere1) {
                    setErrors(false);
                    setStep(step + 1);
                } else {
                    setErrors(true);
                }
        }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSelectChange = (options) => {
        console.log(options)
         setLength(options.length)
        if (options.length < 6) {
            dataForm['matiere1'] = options[0]?.value || ''
            dataForm['matiere2'] = options[1]?.value || '' 
            dataForm['matiere3'] = options[2]?.value || ''
            dataForm['matiere4'] = options[3]?.value || ''
            dataForm['matiere5'] = options[4]?.value || ''
        }
      };
      
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            console.log(dataForm.matiere1)
            const formData = new FormData();
            const nameFiles = ["cv","copie_carte_id","demande","lettre_motivation","copie_diplome","communication","recommandation1","recommandation2","resume_these",
            "publication_scientifique","attestation_travail","justificatif1","justificatif2","justificatif3","justificatif4","justificatif5","justificatif6",
            "diplome2","diplome3","diplome4","diplome5","diplome6","justificatif7","justificatif8","communication2","communication3","communication4",
            "communication5","publication2","publication3","publication4","publication5","publication6","publication7","publication8","publication9","publication10"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
            for (let key in dataForm) {
                // console.log(dataForm[key])
                if (dataForm.hasOwnProperty(key)) {
                      if( (dataForm[key] !== null) || dataForm[key] !== 'undefined') {
                        if (key === 'pays') {
                            if (dataForm['type_poste'] === 'PATS') {
                                if (dataForm['pays'] !== 'senegal') {
                                    dataForm['pays'] = 'SENEGAL'
                                }
                            }
                        }
                        formData.append(key ,dataForm[key])
                      }
              }
            }
            if (!dataForm.departement || !dataForm.disponibilite || !dataForm.duree || !dataForm.matiere1) {
                setErrors(true)
                return
            } else {
                setErrors(false)
            }
            console.log(length)
            if (length > 5 || length === 0) {
                setErrors(true)
                return
            }
            let showALerte = nameFiles.some(field => selectedFiles[field] === false);
         for (let pair of formData.entries()) {
                console.log(pair[0] + ':' + pair[1]);
              }
            if (!valid.isValidPhoneNumber) {
                // setMessageAlerte('Incorrect')
                // setShow(true);
            
            }
            else if (!dataForm.matiere1) {
                alert('une matiere est obligatoire ')
            }
            else if (showALerte) {
                 setShow(true);
                //  setOk(false)
            }
            else {
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    'https://depot.uam.sn/api/v1/vacation/',
                    formData,
            {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            console.log(response)
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    setMessage(response.data.detail)
                    // console.log(response.data.detail)
                    setDeppotSuccess2(true)
                } else {
                    // console.log(response)
                    setSubmitted(false);
                    // console.log('Files uploaded successfully');
                    // console.log('Recepissé :' + response?.data?.data)
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                    // console.log("message : " + response.data.message);
                    // console.log(data);
                }
            } else {
                console.error('Error uploading files');
                console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
       console.error('Error', error);
    }
};
    const handleCheckbox = (event) => {
        if (event.target.name === 'diplome') {
            setDataForm({ ...dataForm, [event.target.name]: event.target.value });
        }
        console.log(event.target.name, event.target.value)
        // Stocker directement le niveau sélectionné (L1, L2, L3, M2, ME, MG)
        setNiveau(event.target.value);
    }
    const calculateProgress = () => {
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
      
  return (
    <>
    <Alert show={show} handleClose={handleClose} />
    {/* {depotsuccess2 ? <Alert2 message = {message} /> : null } */}
    {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
    <div>
        <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
            {/* <Button variant='success' className=' p-2' onClick={handleUpdate}>Modifier son dossier </Button>  */}
            {/* <Button variant='success' className=' p-1 '>Supprimer  son dossier </Button>*/}
        </div>
    </div>
      <div className='container mb-2 ' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            <div className="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div>
        </div>
        <div id='nameModule' className=''>
                    <p> {step===1 ? 'Informations personnelles' : 'Informations Complémentaires' }</p>
        </div>
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div style={{marginLeft:'10px'}}>
                <br />
                {step === 1 && (
                    <div id="step1" className='mb-3'>
                        <Input type='email' focus={true} value={dataForm.email || ''} label="Adresse mail" name='email' onChange={handleChange} />
                            <div className='row' id='test'>
                            <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                            <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                            </div>
                            <div className='row'>
                                {/* <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} /> */}
                                {/* {older ? <span style={{color:'red'}}>Le concours  est ouvert aux bacheliers âgés de 22 ans au maximum en 2023.. </span>: null} */}
                                <Input className="" value={dataForm.fonction || ''} type='text' label="Fonction actuelle" name='fonction' onChange={handleChange} />
                            </div> 
                            <InputT type='number' value={dataForm.telephone || ''} label="Téléphone"  name='telephone' onChange={handleChange} />
                            <Input type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
                            <Form.Group id='niveau'>
                            <Form.Label className='fw-medium'>Diplôme (le plus élevé) <span style={{color:'red'}}>*</span> </Form.Label>
                            <InputRadio checked={dataForm.diplome === "Doctorat"} name='diplome' value="Doctorat" label="Doctorat" onChange={(e) => handleCheckbox(e)}/>
                            <InputRadio checked={dataForm.diplome === "Master"} name='diplome' value="Master" label="Master" onChange={(e) => handleCheckbox(e)}/>
                            {/* <InputRadio name='diplome' value="Master" label="Master" onChange={(e) => handleCheckbox(e)}/> */}
                            <InputRadio checked={dataForm.diplome === "PHD"} name='diplome' value="PHD" label="PHD" onChange={(e) => handleCheckbox(e)}/>
                            <InputRadio checked={dataForm.diplome === "Ingenieur"} name='diplome' value="Ingenieur" label="Ingenieur" onChange={(e) => handleCheckbox(e)}/>
                </Form.Group>
                            
                    </div>
                )}
                {/* terminaison de step 1 */}
                {/* step 2 */}
                {step === 2 && (
                <div className='mb-3'>
                <Form.Group id='ecole'>
                    <Form.Label className='fw-medium'>Etablissement<span style={{color:'red'}}>*</span> </Form.Label>
                    <Form.Select name='departement' required value={dataForm.departement}  className='mb-2'  onChange={handleChange}>
                        <option value="" >--- Selectionner ---</option>
                        <Fragment>
                            {/* <InputOption label="Sciences et Technologies Avancées (STA)"  value="STA"/> */}
                            <InputOption label="Ecole supérieure Polytech Diamniadio"  value="POLYTECH"/>
                            {/* <InputOption label="ESTI" />
                            <InputOption label="ESMGE" />
                            <InputOption label="ES2A" />
                            <InputOption label="ESU2A" /> */}
                        </Fragment>
                    </Form.Select>     
                </Form.Group>
                {dataForm.departement ==='POLYTECH'
                ?   <Form.Group id='niveau'>
                        <Form.Label className='fw-medium'>Niveau d'étude à enseigner <span style={{color:'red'}}>*</span> </Form.Label>
                        {/* <InputCheckbox value="L1" label="L1" onChange={(e) => handleCheckbox(e)}/>  */}
                        {/* <InputCheckbox value="L2" label="L2" onChange={(e) => handleCheckbox(e)}/>
                        <InputCheckbox value="L3" label="L3" onChange={(e) => handleCheckbox(e)}/>
                        <InputCheckbox value="ME" label="Master Economie " onChange={(e) => handleCheckbox(e)}/> */}
                        <InputCheckbox value="M2" label="M2" name="M2" onChange={(e) => handleCheckbox(e)}/>
                    </Form.Group>
                : null }
                
                {dataForm.departement ==='POLYTECH' ?
                <>
                    <Form.Label className='fw-medium'>Matiere (s) à dispenser <span style={{color:'red'}}>*</span> </Form.Label>
                    <Select
                        isMulti
                        autoFocus
                        value={dataForm.options}
                        onChange={handleSelectChange}
                        options={options[niveau] || []}
                        isSearchable={true}
                        placeholder="Choisissez des matieres "
                    />
                </>: null}
                {length > 5 ? 
                <>
                    <div className="alert alert-danger" role="alert">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                        </svg> Le nombre maximal de matiere est de 5
                    </div>
                </> : null}
                <div className='mb-3'>
                    <Input className="" value={dataForm.disponibilite || ''} type='text' label="Disponibilité (Mois / jour)" name='disponibilite' onChange={handleChange}/>
                    <Input className="" value={dataForm.duree || ''} type='text' label="Durée maximale d'enseignement / jour" name='duree' onChange={handleChange}/>
                    <InputF required={true} className="rounded-left mb-2" label="CV" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                    {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true}  className="rounded-left mb-2" label="Copie légalisée du diplome le plus élevé" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_diplome' onChange={(e) => handleFileChange(e,"copie_diplome")} />
                    {!selectedFiles["copie_diplome"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null} 
                    <InputF  className="rounded-left mb-2" label="Tout document pouvant justifier une expérience pédagogique"  type='file' name='justificatif1' onChange={(e) => handleFileChange(e,"justificatif1")} />
                    {!selectedFiles["justificatif1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null} 
                </div>
                </div>
                )}
           </div>
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step === 1 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 2 && 
                <Button  variant="primary" type='submit' size="md"
                // disabled={!ok}
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
        </div>
        </div>
      </div>
    </>
  )
}
export default Vacation